export const getNextElementInArray = <ARRAY_ITEM, CURRENT_ITEM = ARRAY_ITEM>(
    currentElement: CURRENT_ITEM,
    array: Array<ARRAY_ITEM>,
    equal: (arrayItem: ARRAY_ITEM, currentElement: CURRENT_ITEM) => boolean = (
        arrayItem,
        currentElement
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) => (arrayItem as any) === (currentElement as any)
): ARRAY_ITEM => {
    const idx = array.findIndex((item) => equal(item, currentElement));
    if (idx === -1) {
        throw new Error();
    }
    const nextIdx = idx === array.length - 1 ? 0 : idx + 1;
    return array[nextIdx];
};
